module.exports = __webpack_public_path__ + "img/community05.eec35bfb.png";